module.exports = __webpack_public_path__ + "img/1440.1d3b5b26.jpg";